import {Button} from '@wandb/components';
import React, {type FC} from 'react';
// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// oxlint-disable-next-line wandb/no-deprecated-imports
import {toast} from 'react-toastify';

import {useTriggerRecomputeSystemMetricsMutation} from '../generated/graphql';
import {useAdminModeActive} from '../util/admin';

type RunTriggerRecomputeSystemMetricsProps = {
  runID: string;
};

export const RunTriggerRecomputeSystemMetrics: FC<
  RunTriggerRecomputeSystemMetricsProps
> = ({runID}: RunTriggerRecomputeSystemMetricsProps) => {
  const isAdmin = useAdminModeActive();
  const [triggerRecomputeSystemMetrics] =
    useTriggerRecomputeSystemMetricsMutation();

  if (!isAdmin) {
    return null;
  }

  const onClick = async () => {
    try {
      const response = await triggerRecomputeSystemMetrics({
        variables: {runId: runID},
      });
      if (response.errors != null) {
        toast('error triggering recompute system metrics');
        return;
      }
      const taskID = response.data?.triggerRecomputeSystemMetrics?.task?.id;
      if (taskID != null) {
        toast(`successfully triggered recompute system metrics ${taskID}`);
      }
    } catch (err) {
      toast(`error triggering recompute system metrics ${err}`);
    }
  };

  return (
    <Button size="sm" onPress={onClick}>
      Trigger
    </Button>
  );
};
